module.exports = __webpack_public_path__ + "img/linked_list_pointers.3614379a.png";